// import appInfo from '@/app-info'
// import axios from 'axios'
// import router from '@/router';

const emptyData = {
  DcoId: null,
  Company: null,
  DceGroupName: null,
  Department: null,
  CustomerType: null,
  Contact: null,
  PhoneNumber: null,
  TenantPortalState: null,
  TechContactName: null,
  TechContactEmail: null,
  ServerCode: null,
  CustomerLogo: null,
  CustomerName: null,
  ContractedPower: null,
  IsLogoSet: null,
  Username: null,
  UserId: null,
  Id: null,
  Note: null,
  IsDeleted: null,
  CreatedDate: null,
  CreatedBy: null,
  ModifiedDate: null,
  ModifiedBy: null,
  uploadedFile: ''
}

const validationRules = {
  TagName: [
    {
      required: true,
      message: 'Tag Name is required',
      trigger: 'blur'
    }
  ],
  CustomerName: [],
  TagType: [],
  Note: [],
  Attachment: ''
}

export default {
  getEmptyData() {
    return emptyData
  },
  getValidationRule() {
    return validationRules
  }
}
